import { Pressable, type GestureResponderEvent } from "react-native";
import { control, spacing, useTheme } from "~/styles/theme";
import { BodyText } from "./Text";

type Variant = "primary" | "secondary" | "ghost" | "danger";

type Props = {
  label: string;
  onPress: (event: GestureResponderEvent) => void;
  variant?: Variant;
  disabled?: boolean;
  fullWidth?: boolean;
};

export function Button({
  label,
  onPress,
  variant = "primary",
  disabled,
  fullWidth,
}: Props) {
  const { colors } = useTheme();

  const palette: Record<
    Variant,
    { bg: string; fg: string; borderColor: string; borderWidth: number }
  > = {
    primary: {
      bg: colors.ink,
      fg: colors.inverse,
      borderColor: colors.ink,
      borderWidth: 1,
    },
    secondary: {
      bg: "transparent",
      fg: colors.ink,
      borderColor: colors.ruleStrong,
      borderWidth: 1,
    },
    ghost: {
      bg: "transparent",
      fg: colors.ink,
      borderColor: "transparent",
      borderWidth: 0,
    },
    danger: {
      bg: "transparent",
      fg: colors.danger,
      borderColor: colors.danger,
      borderWidth: 1,
    },
  };
  const p = palette[variant];

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={label}
      accessibilityState={{ disabled: Boolean(disabled) }}
      onPress={onPress}
      disabled={disabled}
      style={({ pressed }) => [
        {
          height: control.height,
          paddingHorizontal: spacing.lg,
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: p.bg,
          borderColor: p.borderColor,
          borderWidth: p.borderWidth,
          opacity: disabled ? 0.4 : pressed ? 0.7 : 1,
          alignSelf: fullWidth ? "stretch" : "flex-start",
        },
      ]}
    >
      <BodyText weight="semibold" color={p.fg}>
        {label}
      </BodyText>
    </Pressable>
  );
}
